import { useCallback } from 'react'
import { Button, TableCell, TableRow } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { roleListId, roleType } from '../../config/roleList'
import { checkUserRole } from '../../common/checkUserRole'
import { DELETE_CONFIRM } from '../../constants/form'
import { deleteDefectiveGroup } from '../../store/actions/defectiveGroupAction'

const DefectiveGroupList = ({ defectiveGroup }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { userInfo } = useSelector((state) => state.auth)
    const { roleList } = useSelector((state) => state.user)

    const handleDelete = useCallback(
        (id) => {
            if (window.confirm(DELETE_CONFIRM)) {
                dispatch(deleteDefectiveGroup(id))
            }
        },
        [dispatch]
    )

    return (
        <TableRow>
            <TableCell>
                {moment(defectiveGroup?.createdAt).format('ll')}
            </TableCell>
            <TableCell>{defectiveGroup?.groupName}</TableCell>
            <TableCell>{defectiveGroup?.note}</TableCell>

            <TableCell>
                <div className="button-box">
                    <Button
                        size="small"
                        variant="outlined"
                        color="info"
                        onClick={() =>
                            checkUserRole(
                                userInfo,
                                roleList,
                                roleListId.DEFECTIVE_ITEM,
                                roleType.READ
                            )
                                ? navigate(
                                      `/defective-group/${defectiveGroup.id}`
                                  )
                                : alert('Not Permit User')
                        }
                    >
                        Info
                    </Button>
                    {defectiveGroup?.defectiveitems?.length === 0 && (
                        <Button
                            size="small"
                            variant="outlined"
                            color="error"
                            onClick={() =>
                                checkUserRole(
                                    userInfo,
                                    roleList,
                                    roleListId.DEFECTIVE_ITEM,
                                    roleType.DELETE
                                )
                                    ? handleDelete(defectiveGroup.id)
                                    : alert('Not Permit User')
                            }
                        >
                            Delete
                        </Button>
                    )}
                </div>
            </TableCell>
        </TableRow>
    )
}

export default DefectiveGroupList
